export const formatUndefinedToDash = (input: string | undefined): string => {
  return input ? input : "-";
};
